import {
  URL_LOOKUP,
} from './../../mutation-types';

export default {
  [URL_LOOKUP](state, ulresp) {
    state.url = ulresp.url;
    state.lists = ulresp.lists;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/urllookup/mutations.js